<form class="now-typeahead" [formGroup]="form" (focusout)="focusOut($event)" action=".">
  <div class="form-group" #formGroup>
    <label id="typeahead-{{ id }}-label" for="typeahead-{{ id }}">{{ label }}</label>
    <div class="dropdown form-typeahead">
      <div class="input-group input-group-override">
        @if (iconClass) {
          <i [class]="iconClass" [class.disabled]="disable"></i>
        }
        <input
          #inputField
          id="typeahead-{{ id }}"
          class="form-control"
          type="search"
          title="Wenn Vorschläge verfügbar sind, können die Hoch- und Runter-Pfeiltasten zum Navigieren und die Enter-Taste zum Selektieren verwendet werden."
          (keyup)="onKeyUp($event)"
          (focus)="setActive(-1)"
          [class.extra-padding]="iconClass"
          [formControl]="inputControl"
          [maxlength]="maxlength"
          [placeholder]="placeholder"
          role="combobox"
          autocomplete="off"
          aria-autocomplete="both"
          [attr.aria-expanded]="showSuggestions"
          [attr.aria-controls]="'typeahead-menu-' + id"
          [attr.aria-activedescendant]="
            activeSuggestionIndex >= 0 ? 'selectedOption-' + id + '-' + activeSuggestionIndex : null
          "
        />
        @if (inputField.value !== '') {
          <button
            [id]="id + '_clear'"
            type="button"
            class="clean-and-close now-btn-icon-only now-icon-x"
            (click)="cleanAndClose()"
            [attr.aria-label]="label + ' löschen'"
          ></button>
        }
      </div>
      <ul
        #suggestionsUl
        id="typeahead-menu-{{ id }}"
        tabindex="-1"
        class="dropdown-menu"
        role="listbox"
        [class.show]="showSuggestions"
        [attr.aria-labelledby]="'typeahead-' + id + '-label'"
        (keyup)="onKeyUp($event)"
      >
        @for (suggestion of suggestions; track suggestion; let idx = $index) {
          <li
            #option
            id="{{ 'selectedOption-' + id + '-' + idx }}"
            tabindex="-1"
            role="option"
            [attr.aria-selected]="idx === activeSuggestionIndex ? 'true' : 'false'"
            (click)="onClickSuggestion(idx)"
            (focus)="setActive(idx)"
            [ngClass]="{ 'now-focused': idx === activeSuggestionIndex }"
            class="dropdown-item"
          >
            <a tabindex="-1" class="{{ suggestion.cssClass }}">
              <!-- Dieses DIV darf nicht entfernt werden! Siehe SCSS. -->
              <div [innerHTML]="render(suggestion)"></div>
            </a>
          </li>
        }
      </ul>
    </div>
    @if (!!hilfstext) {
      <p id="typeahead-form-text" class="form-text">
        {{ hilfstext }}
      </p>
    }
  </div>
</form>
